export default "__VITE_ASSET__BCi0U2qZ__"